import type { components } from '@connected/api-client/api.generated';

import { z } from 'zod';

export type ElectricalProjectInspectionKind = z.infer<typeof electricalProjectInspectionKindEnum>;
export type ElectricalProjectTemplate = z.infer<typeof electricalProjectTemplateSchema>;
export type ElectricalProjectWithNorms = z.infer<typeof electricalProjectSchema>;

const ELECTRICAL_PROJECT_INSPECTION_KIND_ENUM = ['None', 'Scope8', 'Scope10', 'Scope12', 'Nen1010', 'Nen3140'] as const satisfies readonly components['schemas']['ElectricalInspectionKind'][];

export const electricalProjectInspectionKindEnum = z.enum(ELECTRICAL_PROJECT_INSPECTION_KIND_ENUM);

export const electricalProjectTemplateSchema = z.object({
    electricalProjectDocumentTemplateId: z.string(),
    inspectionKind: z.enum(ELECTRICAL_PROJECT_INSPECTION_KIND_ENUM),
});

export const electricalProjectSchema = z.object({
    electricalProjectVersionId: z.string(),
    enabledElectricalProjectPriceQuote: z.boolean().nullable(),
    enabledElectricalProjectPlanning: z.boolean().nullable(),
    enabledElectricalProjectRecommendations: z.boolean().nullable(),
    isCombinationInspection: z.boolean().nullable(),
    selectedTemplates: z.array(electricalProjectTemplateSchema),
    /**
     * @deprecated Use `api.useMutation('put', '/api/v2/electrical/projects/norms/patch', ...)` instead.
     */
    selectedInspections: z.array(z.string()).nullable().optional(),
    selectedInspectionKinds: z.set(z.enum(ELECTRICAL_PROJECT_INSPECTION_KIND_ENUM)),
});
